import { IEventType } from '../graphql/types';
export interface Event {
  _id: string;
  description: string;
  type: IEventType;
}

export const EVENT_TYPES: IEventType[] = ['DISTANCE', 'STEPS', 'TIMEBOXED'];
